/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S2_Grace_TermInputs */

const tr_iade_iptal_s2_grace_term = /** @type {(inputs: Iade_Iptal_S2_Grace_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik Sonrası Erişim:`)
};

const en_iade_iptal_s2_grace_term = /** @type {(inputs: Iade_Iptal_S2_Grace_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access after expiry:`)
};

const de_iade_iptal_s2_grace_term = /** @type {(inputs: Iade_Iptal_S2_Grace_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugang nach dem Ende:`)
};

const ru_iade_iptal_s2_grace_term = /** @type {(inputs: Iade_Iptal_S2_Grace_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступ после окончания:`)
};

/**
* | output |
* | --- |
* | "Access after expiry:" |
*
* @param {Iade_Iptal_S2_Grace_TermInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s2_grace_term = /** @type {((inputs?: Iade_Iptal_S2_Grace_TermInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S2_Grace_TermInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s2_grace_term(inputs)
	if (locale === "de") return de_iade_iptal_s2_grace_term(inputs)
	if (locale === "ru") return ru_iade_iptal_s2_grace_term(inputs)
	return tr_iade_iptal_s2_grace_term(inputs)
});